<template>
  <div class="cart-option">
    <div class="form-group">
      <div class="custom-control custom-radio">
        <input id="d1" type="radio" class="custom-control-input" :checked="!pickup" @change="unsetPickup">
        <label for="d1" class="custom-control-label">Lieferung an die angegebene Addresse</label>
      </div>
    </div>
    <div class="form-group">
      <label>Zielland:</label>
      <select class="custom-select" @change="changeCountry">
        <option v-for="(c, index) in countries" :key="index" :selected="c.name == country.name">
          {{ c.name }}
        </option>
      </select>
    </div>
    <div class="form-group">
      <div class="custom-control custom-radio">
        <input id="d2" type="radio" class="custom-control-input" :checked="pickup" @change="setPickup">
        <label for="d2" class="custom-control-label">Selbstabholung</label>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      countries: 'checkout/countries',
      country: 'checkout/country',
      pickup: 'checkout/pickup'
    })
  },
  methods: {
    ...mapActions({
      selectDelivery: 'checkout/selectDelivery',
      updatePickup: 'checkout/updatePickup'
    }),
    setPickup (e) {
      this.updatePickup(true)
    },
    unsetPickup (e) {
      this.updatePickup(false)
    },
    changeCountry (e) {
      this.selectDelivery(e.target.value)
    }
  }
}
</script>
